import { render, staticRenderFns } from "./CreateFormPlat.vue?vue&type=template&id=830fd3b4"
import script from "./CreateFormPlat.vue?vue&type=script&lang=js"
export * from "./CreateFormPlat.vue?vue&type=script&lang=js"
import style0 from "./CreateFormPlat.vue?vue&type=style&index=0&id=830fd3b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports